import { render, staticRenderFns } from "./myCalendar.vue?vue&type=template&id=980ad334&"
import script from "./myCalendar.vue?vue&type=script&lang=js&"
export * from "./myCalendar.vue?vue&type=script&lang=js&"
import style0 from "./myCalendar.vue?vue&type=style&index=0&id=980ad334&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports